<template>
  <div class="facebook-comments-container">
    <div ref="fbComments" class="fb-comments" :data-href="url" data-width="100%" data-numposts="5"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue';

export default {
  name: 'FacebookCommentComponent',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const fbComments = ref(null);

    const loadFacebookSDK = () => {
      // Remove any existing Facebook SDK script
      const existingScript = document.getElementById('facebook-jssdk');
      if (existingScript) {
        existingScript.remove();
      }

      // Create new script
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0';
      script.nonce = 'random_nonce';
      script.crossorigin = 'anonymous';
      script.nonblocking = true;

      // Add script to document
      document.head.appendChild(script);

      // Initialize Facebook SDK
      window.fbAsyncInit = function() {
        /* global FB */
        FB.init({
          appId: 'your_app_id', // Replace with your Facebook App ID
          cookie: true,
          xfbml: true,
          version: 'v18.0'
        });
      };
    };

    const reinitializeComments = () => {
      // Remove existing comments
      if (fbComments.value) {
        fbComments.value.innerHTML = '';
      }

      // Reload Facebook SDK
      loadFacebookSDK();

      // Force Facebook to re-render comments
      if (window.FB) {
        window.FB.XFBML.parse();
      }
    };

    // Watch for URL changes
    watch(() => props.url, () => {
      reinitializeComments();
    });

    onMounted(() => {
      reinitializeComments();
    });

    onUnmounted(() => {
      // Clean up Facebook SDK
      const script = document.getElementById('facebook-jssdk');
      if (script) {
        script.remove();
      }
      if (window.FB) {
        window.FB = undefined;
      }
    });

    return {
      fbComments,
    };
  },
};
</script>

<style scoped>
.facebook-comments-container {
  width: 100%;
  margin: 2rem 0;
  background: white;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

.fb-comments {
  width: 100% !important;
  min-height: 100px;
}

@media (max-width: 768px) {
  .facebook-comments-container {
    width: 100% !important;
    margin: 1rem 0 !important;
    padding: 15px !important;
    position: static !important;
    z-index: auto !important;
  }

  .fb-comments {
    width: 100% !important;
    min-height: 100px;
  }

  /* Force all child elements to have no stacking context */
  .facebook-comments-container * {
    position: static !important;
    z-index: auto !important;
    transform: none !important;
    will-change: auto !important;
  }
}
/* Add any custom styles for your component here */
</style>
  